import { createContext, use } from 'react'

/**
 * Control size. `compact` fits dense editors, `small` fits toolbars.
 */
export type ControlSize = 'normal' | 'compact' | 'small'

/**
 * Sizes the controls inside it that don't set a size of their own.
 */
export const ControlSizeContext = createContext<ControlSize | undefined>(
  undefined,
)

/**
 * Gets the size to use for a control.
 *
 * @param size The control's own size, which wins when specified.
 */
export function useControlSize(size?: ControlSize): ControlSize {
  return size ?? use(ControlSizeContext) ?? 'normal'
}
